import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AccountContext } from 'components/AccountContext';
import { userIsSubscriber } from 'components/Utils/theme';
import { Box, Text, useToast } from '@chakra-ui/react';
import { api } from 'api/api';

const ENDPOINT =
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_BASE_URL_API_SERVER_PROD
    : process.env.REACT_APP_BASE_URL_API_SERVER_TEST;

const useModelCardsTelemedicina = () => {
  const { user, setUser } = useContext(AccountContext);
  const navigate = useNavigate();
  const assinante = userIsSubscriber(user);
  const toast = useToast();
  const [loadingPet, setLoading] = useState(false);

  async function handleTelepet(gratuito, valor = null, disclosure) {
    try {
      setLoading(true);
      await api(`${ENDPOINT}/pacientes/getStatusTelepet`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: null,
      })
        .then(async (res) => {
          if (!res || !res.ok || res.status >= 400) {
            setLoading(false);
            return;
          }
          return await res.json();
        })
        .then(async (resposta) => {
          setLoading(false);
          if (!resposta) {
            toast({
              render: () => (
                <Box color="white" bg="#5AB2AE" p={3} borderRadius="md">
                  <Text fontWeight="bold">Importante</Text>
                  <Text>Serviço indisponível no momento. Nosso horário de atendimento é de segunda a sexta, das 7h às 11h e das 13h às 17h.</Text>
                </Box>
              ),
              duration: 4000,
              isClosable: true,
              position: 'bottom',
              containerStyle: {
                paddingBottom: '5em',
              },
            });
            return;
          }

          if (gratuito || valor === 0) {
            setUser((prevUser) => ({
              ...prevUser,
              paga_telemedicina: false,
            }));
            navigate('/aviso-pre-atendimento/', {
              state: { titulo: 'Telemedicina Pet', tela: '/telepet/termos/', pediatra: false },
            });
            return;
          }
          if (!assinante) {
            disclosure.onOpen();
            return;
          }
          navigate('/pagamento-telemedicina', {
            state: { tipoAtendimento: 'veterinario', telemedicina: true },
          });
        });
    } catch (error) {
      setLoading(false);
    }
  }

  return {
    navigate,
    assinante,
    setUser,
    toast,
    user,
    loadingPet,
    handleTelepet,
  };
};

export default useModelCardsTelemedicina;
